import { Box, Button, ButtonAppearance, ButtonSize } from '@bechtel/gds';
import { MultiLingualText } from '~/components';
import { NavLink, NotFoundStyled } from './styled';
//@ts-ignore images ignore
import { ReactComponent as BlockConstructionIcon } from '~/images/block-construction.svg';

export const NotFound = () => {
  return (
    <Box flexDirection={{ sm: 'column' }} style={{ margin: 'auto' }}>
      <Box mb={{ sm: '900' }} flexDirection={{ sm: 'column' }} alignItems={{ sm: 'center' }}>
        <NotFoundStyled>
          <BlockConstructionIcon />
        </NotFoundStyled>
        <Box mt={{ sm: '600' }} mb={{ sm: '400' }}>
          <MultiLingualText size="500" weight="600">
            The page you are looking for cannot be found.
          </MultiLingualText>
        </Box>
        <Box py={{ sm: '200' }}>
          <MultiLingualText color="grey.600" size="400">
            Please check the URL.
          </MultiLingualText>
        </Box>
        <NavLink href="/">
          <Button size={ButtonSize.MEDIUM} appearance={ButtonAppearance.PRIMARY}>
            <MultiLingualText size="400" weight="600">
              Back
            </MultiLingualText>
          </Button>
        </NavLink>
      </Box>
    </Box>
  );
};
